module.exports = __webpack_public_path__ + "img/酒星科技.7257eee5.jpg";